import { createStyles, Theme } from '@material-ui/core'

export const styles = (theme: Theme) =>
  createStyles({
    cardContent: {
      padding: theme.spacing(2),
      paddingTop: '0px !important',
      justifyContent: 'space-between',
      // height: '100%',
      display: 'flex',
      flexDirection: 'column'
    },
    dataTableWithoutHeader: {
      minHeight: '0px'
      // '& .MuiToolbar-root': {
      //   display: 'none'
      // },
      // '& .MuiToolbar-root': {
      //   // paddingLeft: theme.spacing(0),
      //   display: 'none !important'
      // }
    },
    cardActionsRight: {
      display: 'flex',
      justifyContent: 'flex-end'
    }
  })
